import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core"; 

@Component({
  selector: "kreform-panel",
  template: `
    <kreform-field
      *ngFor="let f of field.fieldGroup"
      [field]="f"
    ></kreform-field>
    <ng-content></ng-content>
  `,
  host: {
    "[class]": 'field.className || ""',
    cdkDrag: "",
  },
})
export class KreFormFieldPanel extends FieldType {}
